/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import useUser from '../../../Shared/UserProvider/useUser'
import { useQuery } from '@tanstack/react-query'
import { isProviderAPos } from '../../../../services/Provider/Provider.service'
import { getNextClosure } from '../../../../services/PointOfSale/PointOfSale.service'
import { differenceInMinutes, format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardExtra } from '../../Shared/Card'
import { Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom-v5-compat'
import { LoadingPlaceholderCardContent } from '../../Shared/LoadingPlaceholderCardContent'


const NextClosureCard = () => {
    const [t] = useTranslation()
    const {user} = useUser()

    const {data, isLoading} = useQuery({
        queryKey: ['next-closure', user.provider.object.id],
        queryFn: () => getNextClosure(user.provider.object.id),
        enabled: isProviderAPos(user.provider),
    })

    const getClosureText = () => {
        if (!data) return ''
        if (data === 'NEVER') return t('dashboard.next_closure.always_open')
        if (data === 'CLOSED') return t('dashboard.next_closure.closed')

        const minutesUntilClosure = differenceInMinutes(new Date(data), new Date())

        if (minutesUntilClosure < 60) {
            return t('dashboard.next_closure.close_in_minute', {count: minutesUntilClosure})
        }

        const closureTime = format(new Date(data), 'H\'h\'mm')
        return t('dashboard.next_closure.close_at', {time: closureTime})
    }

    return (
      <Card
        css={css`
            border-top: ${isLoading ? '0' : '2px'} solid grey;

            .card-content {
                width: 225px;
                height: 62px;
            }
        `}
      >
          {isLoading ? (
            <LoadingPlaceholderCardContent/>
          ) : (
            <CardContent
              css={css`
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
              `}
            >
                <div
                  css={css`
                      display: flex;
                      align-items: center;
                      column-gap: 1rem;
                      margin-left: 1rem;
                  `}
                >
                    <Icon name="clock outline" size="big"/>
                    <p
                      css={css`
                          font-weight: bold;
                      `}>
                        {getClosureText()}
                    </p>
                </div>
            </CardContent>

          )}
          <CardExtra>
              <Link
                to={{
                    pathname: '/settings/hours',
                }}>
                  Horaires
                  <Icon name="arrow right"/>
              </Link>
          </CardExtra>
      </Card>
    )
}

export { NextClosureCard }
